var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.layout,
    {
      tag: "component",
      attrs: {
        favorites: _vm.favorites,
        currentLang: _vm.currentLang,
        menus: _vm.visibleMenus,
        subMenus: _vm.subMenus,
        customMenus: _vm.customMenus,
        customTabs: _vm.customTabs,
        menusActiveID: _vm.menusActiveID,
        panes: _vm.panes,
        panesHistory: _vm.panesHistory,
        activeKey: _vm.activeKey,
        subjectMode: _vm.subjectMode,
      },
      on: {
        menuschange: _vm.handleMenusChange,
        menuchange: _vm.handleMenuChange,
        addcustommenu: _vm.handleCustomMenuAdd,
        removecustommenu: _vm.handleCustomMenuRemove,
        editcustommenu: _vm.handleCustomMenuEdit,
        menupushpin: _vm.handleMenuPushpin,
      },
      scopedSlots: _vm._u([
        {
          key: "rightContentRender",
          fn: function () {
            return [
              _c("right-content", { attrs: { subjectMode: _vm.subjectMode } }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.$route.meta.routerView &&
      ["home", "Entry401", "Entry402"].includes(_vm.activeKey)
        ? _c("router-view")
        : _vm._e(),
      _vm._l(_vm.iframes, function (iframe) {
        return [
          _c("iframe", {
            key: iframe.key,
            class: [
              `entry-iframe__${
                iframe.key === _vm.activeKey ? "visible" : "hidden"
              }`,
            ],
            attrs: {
              id: iframe.key,
              src: _vm.iframeUrl(iframe),
              width: "100%",
              height: "100%",
              frameborder: "0",
              allowfullscreen: "true",
            },
          }),
        ]
      }),
      _vm._l(
        _vm.microApps.filter((app) => app.name),
        function (app, index) {
          return [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.params.name === app.name,
                  expression: "$route.params.name === app.name",
                },
              ],
              key: index,
              staticClass: "entry-layout__microapp-wrapper",
              attrs: {
                id: `${_vm.serviceId}-${_vm.systemCode}-${app.name}-view-box`,
              },
            }),
          ]
        }
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.i18nRender("layouts.customscene", [
              _vm.customMenuFormData
                ? _vm.$t("layouts.edit")
                : _vm.$t("layouts.new"),
            ]),
            width: "820px",
            wrapClassName: "custom-form",
            destroyOnClose: "",
          },
          model: {
            value: _vm.customMenuFormVisible,
            callback: function ($$v) {
              _vm.customMenuFormVisible = $$v
            },
            expression: "customMenuFormVisible",
          },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    color: "#252B3A",
                    "font-size": "12px",
                    "line-height": "32px",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.selected")) + " "
                  ),
                  _c("span", { staticStyle: { color: "#C7000B" } }, [
                    _vm._v(_vm._s(_vm.selectMenusLength)),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.action")) + " "
                  ),
                ]
              ),
              _c(
                "a-button",
                {
                  key: "cancel",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.handleCustomMenuFormCancel },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.cancel")) + " "
                  ),
                ]
              ),
              _c(
                "a-button",
                {
                  key: "submit",
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleCustomMenuFormSubmit },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.i18nRender("form-modal.submit")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("custom-menu-form", {
            ref: "customMenuForm",
            attrs: {
              menus: _vm.visibleMenus,
              "form-data": _vm.customMenuFormData,
              "select-menus-length": _vm.selectMenusLength,
              currentLang: _vm.currentLang,
            },
            on: {
              "update:selectMenusLength": function ($event) {
                _vm.selectMenusLength = $event
              },
              "update:select-menus-length": function ($event) {
                _vm.selectMenusLength = $event
              },
            },
          }),
        ],
        2
      ),
      _vm.initPanesFlag && _vm.isAuthStore ? _c("information-up") : _vm._e(),
      !_vm.isDemo && _vm.systemCode === "ERP" && _vm.isAuthStore
        ? _c("lite-tips", { attrs: { guide: _vm.guide } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }